/**
 * External Dependencies
 */
import parse from 'html-react-parser';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, CustomInput, Form, Row } from 'reactstrap';

/**
 * Component
 */
const InformativaContent = ({ embedded, onClose }) => {
  const navigate = useNavigate();

  const [titolo, setTitolo] = useState('');
  const [testo, setTesto] = useState('');
  const [checkboxInformativa, setCheckboxInformativa] = useState(false);
  const [informativaAccettata, setInformativaAccettata] = useState(false);

  const submitForm = async e => {
    e.preventDefault();
    if (checkboxInformativa) {
      window.api.auth
        .enablePolicy()
        .then(() => {
          setInformativaAccettata(true);
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      window.swal.fire({
        icon: 'warning',
        text: "E' necessario accettare l'informativa per continuare.",
      });
    }
  };

  const getInformativa = () => {
    window.api.auth
      .getPolicy()
      .then(res => {
        const { title, body } = res.data.informativa;
        setTitolo(title);
        setTesto(body);

        if (res.data.policy) {
          setInformativaAccettata(true);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    getInformativa();
  }, []);

  useEffect(() => {
    if (informativaAccettata) {
      if (embedded === true) {
        onClose();
      } else {
        navigate(-1);
      }
    }
  }, [informativaAccettata, embedded, onClose, navigate]);

  return (
    <>
      <Form id="form" onSubmit={submitForm}>
        <h3 className="titolo-informativa">{titolo}</h3>
        <div className="testo-informativa">{parse(testo)}</div>
        <Row>
          <Col>
            <Row>
              <CustomInput
                checked={checkboxInformativa}
                label="Ho letto e accetto l'informativa"
                type="checkbox"
                className="fancy-checkbox-left"
                name="checkboxInformativa"
                id="checkboxInformativa"
                onClick={e => setCheckboxInformativa(e.target.checked)}
              />
            </Row>
          </Col>
        </Row>
        <Button form="form" color="brand">
          Continua
        </Button>
      </Form>
    </>
  );
};

export default InformativaContent;
